import { VendorRentalUploadPage } from "@/features/vendor-app/pages/VendorRentalUploadPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/rental/new")({
	component: VendorRentalUploadPage,
});
